export function logUncaughtErrors(logger) {
    // Grab existing onerror handlers
    const { onerror } = window;
    window.onerror = (...args) => {
        // ignore benign error from Resize Observer
        if (args.length && args.includes('ResizeObserver loop limit exceeded')) {
            return false;
        }
        logger.warn('Error bubbled to window: ', ...args);
        onerror && onerror.apply(window, args);
        return false;
    };
}
//# sourceMappingURL=logUncaughtErrors.js.map